import React from 'react';
import styled from 'styled-components/macro';
import useMedia from 'use-media';

interface Props {
  title: string;
  children: React.ReactNode;
}

const Picker = ({ title, children }: Props) => {
  const isMobile = useMedia({ maxWidth: 1023 });
  return (
    <div className="bg-white">
      {!isMobile && (
        <div className="flex bg-gray-300">
          <StyledTitlePicker>{title}</StyledTitlePicker>
        </div>
      )}

      <div className="flex my-1">{children}</div>
    </div>
  );
};

export default Picker;

export const StyledTitlePicker = styled.div`
  margin: 0 1rem;
`;
